import { Page } from '@dixa/lib-shared-habla';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { NotFoundView } from '../../../notFound';

import { Facebook } from './components/sections/facebook/facebook';
import { Instagram } from './components/sections/instagram/instagram';
import { Twitter } from './components/sections/twitter/twitter';
import { WhatsAppTwilio } from './components/sections/whatsAppTwilio/whatsAppTwilio';

export const SettingsMessagingView = (): JSX.Element => {
  const flags = useFeatureFlag([
    'facebook-messenger-channel',
    'instagram-management',
    'twitter-channel',
    'whatsapp-channel',
    'new-whatsapp-onboarding',
  ]);

  if (Object.values(flags).every((flag) => !flag)) {
    return <NotFoundView name="Dashboard" navigatePath="/dashboard" />;
  }

  return (
    <Page>
      <Page.Head title="Third-party messaging" />

      <Page.Body>
        {flags.whatsappChannel && <WhatsAppTwilio />}
        {flags.facebookMessengerChannel && <Facebook />}
        {flags.instagramManagement && <Instagram />}
        {flags.twitterChannel && <Twitter />}
      </Page.Body>
    </Page>
  );
};
